import { LoadOptions } from 'pixi.js';

export const TEXT_CONTAINER_PADDING = 100;
export const ALPHA_FILTER_PADDING = TEXT_CONTAINER_PADDING;
export const ASSET_LOAD_OPTIONS: Partial<LoadOptions> = {
  strategy: 'retry',
  retryCount: 5,
  retryDelay: 500,
  onError(error, url) {
    console.error(`Error loading asset from url ${url}:`, error);
  }
};
